import classNames from 'classnames'

import { Link } from '@src/quince-components/src'
import Swiper from '@src/quince-components/src/atoms/custom-swiper'
import { NAV_POSITION } from '@src/quince-components/src/atoms/swiper/Swiper'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { getFormattedSlug } from '../../../utils'
import { LinkGroupProps } from '../SubCategoryList'

import styles from './textSubCategoryList.module.scss'

type TextSubCategoryListProps = LinkGroupProps & {
  sendEventOnButtonClick: (...args: unknown[]) => void
}

function TextSubCategoryList({ buttons = [], className, sendEventOnButtonClick }: TextSubCategoryListProps) {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  return (
    <div className={classNames(styles.wrapper, className)}>
      <Swiper
        showDots={false}
        //TODO: Change showNavigator to true once the slider is fixed to snap to the first tile of the next slide
        showNavigator={false}
        numberOfVisibleSlides={9}
        variableWidth
        id={'textWithProductSlider'}
        isChevronIcon
        navPosition={NAV_POSITION.CENTER}
        prevIconClass={styles.prevArrowClass}
        nextIconClass={styles.nextArrowClass}
        arrowWrapperClass={styles.arrowWrapperClass}
      >
        {buttons.map((button, index) => {
          const active = index === 0
          return (
            <Link
              key={button.id}
              className={classNames(styles.subCategoryItem, {
                [styles.active]: active,
              })}
              href={active ? undefined : '/' + getFormattedSlug(button.slug)}
            >
              <h5
                onClick={() => {
                  sendEventOnButtonClick(button.name, buttons)
                }}
                className={styles.subCategoryItemText}
              >
                {button.name}
              </h5>
            </Link>
          )
        })}
      </Swiper>
    </div>
  )
}

export default TextSubCategoryList
